export const PAYMENT_WALLET = "0x374c64a6a95ae4a3dfe6da2c976df22b062bc9f1"